// src/components/common/TabBar.jsx
// 하단 고정 탭 바

import React from 'react';

const TABS = [
  { id: 'home',      label: '홈',    icon: HomeIcon },
  { id: 'calendar',  label: '달력',   icon: CalendarIcon },
  { id: 'send',      label: '메시지', icon: SendIcon },
  { id: 'customers', label: '고객',  icon: PeopleIcon },
  { id: 'marketing', label: '홍보',   icon: StarIcon },
  { id: 'settings',  label: '설정',  icon: SettingsIcon },
];

export default function TabBar({ activeTab, onTabChange }) {
  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: 480,
      height: 'var(--tabbar-h)',
      background: 'white',
      borderTop: '1px solid var(--border)',
      display: 'flex',
      zIndex: 100,
      // iOS 홈바 여백
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      {TABS.map(tab => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              flex: 1,
              border: 'none',
              background: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              cursor: 'pointer',
              color: isActive ? 'var(--green)' : 'var(--text-muted)',
              padding: '8px 0',
              transition: 'color 0.15s',
            }}
          >
            <Icon size={22} active={isActive} />
            <span style={{
              fontSize: 11,
              fontWeight: isActive ? 700 : 500,
              lineHeight: 1,
            }}>
              {tab.label}
            </span>
            {/* 발송 탭은 강조 dot */}
            {tab.id === 'send' && isActive && (
              <div style={{
                position: 'absolute',
                width: 4,
                height: 4,
                borderRadius: '50%',
                background: 'var(--green)',
                marginTop: -20,
                marginLeft: 18,
              }} />
            )}
          </button>
        );
      })}
    </nav>
  );
}

// ─── 아이콘 컴포넌트 ───
function HomeIcon({ size, active }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M3 9.5L12 3L21 9.5V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V9.5Z"
        fill={active ? 'var(--green)' : 'none'}
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SendIcon({ size, active }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M22 2L11 13"
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 2L15 22L11 13L2 9L22 2Z"
        fill={active ? 'var(--green)' : 'none'}
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PeopleIcon({ size, active }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle
        cx="9"
        cy="7"
        r="4"
        fill={active ? 'var(--green)' : 'none'}
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
      />
      <path
        d="M2 21C2 17.134 5.13401 14 9 14C12.866 14 16 17.134 16 21"
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M15 11C16.6569 11 18 9.65685 18 8C18 6.34315 16.6569 5 15 5"
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M19 18C20.7542 18.4 22 19.5 22 21"
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CalendarIcon({ size, active }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect
        x="3" y="4" width="18" height="18" rx="2"
        fill={active ? 'var(--green)' : 'none'}
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
      />
      <path
        d="M16 2V6M8 2V6M3 10H21"
        stroke={active ? 'white' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function StarIcon({ size, active }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={active ? 'var(--green)' : 'none'}
        stroke={active ? 'var(--green)' : 'var(--text-muted)'}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SettingsIcon({ size, active }) {
  const c = active ? 'var(--green)' : 'var(--text-muted)';
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3"
        fill={active ? 'var(--green)' : 'none'}
        stroke={c} strokeWidth="1.8" />
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"
        stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
